import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as EsquemaBalanceGeneralService from 'services/esquemaBalanceGeneral.service'

const Select2CodigoEnlace = ({ id, onChange }) => {
  const loadCuentasSelect = React.useCallback((inputValue, resolve) => {
    EsquemaBalanceGeneralService.obtenerAsSelect2({
      busqueda: inputValue
    })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  return <AsyncSelect selectId={id} loadOptions={loadCuentasSelect} onChange={onChange} />
}

export default React.memo(Select2CodigoEnlace)
